export const buildProductDetailPath = (urlSegment: string, sectionPath: string, slug: string) => {
    return `/${urlSegment}/${[sectionPath, 'detail', slug].filter(Boolean).join('/')}`;
};
